import moment       from "moment";
import PlanTimeType from "../../plan/PlanTimeType";

class Time {
  public static of(value: Date) {
    return new Time(moment(value));
  }

  public static ofText(value: string) {
    const date = moment(`1900-01-01 ${ value }`);
    return new Time(date);
  }

  constructor(private readonly _value: moment.Moment = moment()) {
  }

  public asAText(): string {
    return this._value.format("A h:mm");
  }

  public asText(): string {
    return this._value.format("HH:mm");
  }

  public asHourText(): string {
    return this._value.format("HH");
  }

  public asMinuteText(): string {
    return this._value.format("mm");
  }

  public asDate(): Date {
    return this._value.toDate();
  }

  public addMinute(minute: number): Time {
    const m = this.clone();
    return new Time(this._value.minute(m.toMinuteNumber() + minute));
  }

  public addPlanTimeType(planTimeType: PlanTimeType): Time {
    const minute = this.clone();
    switch (planTimeType) {
      default:
      case PlanTimeType.MINUTE_30:
        return new Time(this._value.minute(minute.toMinuteNumber() + 30));
      case PlanTimeType.MINUTE_15:
        return new Time(this._value.minute(minute.toMinuteNumber() + 15));
      case PlanTimeType.MINUTE_60:
        return new Time(this._value.minute(minute.toMinuteNumber() + 60));
      case PlanTimeType.MINUTE_90:
        return new Time(this._value.minute(minute.toMinuteNumber() + 90));
      case PlanTimeType.MINUTE_120:
        return new Time(this._value.minute(minute.toMinuteNumber() + 120));
    }
  }

  public toMinuteNumber(): number {
    return this._value.minute();
  }

  public clone(): Time {
    return Time.ofText(this.asText());
  }

  public setHour(hour: number): Time {
    return new Time(this._value.hour(hour));
  }

  public setMinute(minute: number): Time {
    return new Time(this._value.minute(minute));
  }

  public isSameOrBefore(other: Time): boolean {
    return this._value.isSameOrBefore(other.value);
  }

  public isSameOrAfter(other: Time): boolean {
    return this._value.isSameOrAfter(other.value);
  }

  public isBefore(other: Time): boolean {
    return this._value.isBefore(other.value);
  }

  public isAfter(other: Time): boolean {
    return this._value.isAfter(other.value);
  }

  get value() {
    return this._value;
  }
}

export default Time;
